import { AnalyticsErrorBoundary } from '../shared/AnalyticsErrorBoundary';
import { SkeletonLoader } from '../shared/SkeletonLoader';
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { useWellnessKPIData } from '../../../hooks/analytics/useWellnessMetrics.tsx';
import { MetricCard } from '../overview/MetricCard';
import { useIsMobile } from '../../../hooks/useIsMobile';

interface WellnessMetricsProps {
  filters: WellnessFilter;
}

function WellnessMetricsContent({ filters }: WellnessMetricsProps) {
  const isNarrow = useIsMobile(1024);
  const { kpiItems, isLoading } = useWellnessKPIData(filters);

  if (isLoading) {
    return <SkeletonLoader variant="metrics" count={4} />;
  }

  return (
    <div
      className={`grid gap-3 ${isNarrow ? 'grid-cols-2' : 'grid-cols-4'}`}
      style={{ ['--anl-metric-bg' as any]: 'var(--anl-surface)' }}
    >
      {kpiItems.map(item => (
        <MetricCard
          key={item.id}
          value={item.value}
          label={item.label}
          secondaryValue={item.secondaryValue?.value}
          secondaryLabel={item.secondaryValue?.label}
          accent={String(item.color)}
          preserveSecondarySpacing
        />
      ))}
    </div>
  );
}

export function WellnessMetrics({ filters }: WellnessMetricsProps) {
  return (
    <AnalyticsErrorBoundary>
      <WellnessMetricsContent filters={filters} />
    </AnalyticsErrorBoundary>
  );
}
